import React from "react";
import InputForm from "../../../../components/ComponentesFormularios/InputForm";
import {ERRORFIELDREQUIRED} from "../../../../data/ConstantForm";
import {Colors} from "../../../../assets/colors/Colors";
import {FormProvider, useForm} from "react-hook-form";
import {adminService} from "../../../../services/apiAdmin";
import {GlobalConstants} from "../../../../data/GlobalConstants";
import {modalSideService} from "../../../../services/modalSideService";
import {useDispatch, useSelector} from "react-redux";
import {CButton} from "@coreui/react";

const FormUsuariosPasswordCRUD = ({ isEditing, isAddMode, properties }) => {

    const { id } = properties;
    const dispatch = useDispatch();
    const authState = useSelector( state => state.auth )
    const { idUsuario: idUsuarioAuditoria } = authState;
    const methods = useForm({defaultValues: { idUsuario: id }});
    const { watch, handleSubmit, control, formState: { errors } } = methods;
    const { newPassword } = watch();

    const onSuccessSubmit = data => {

        data.usrAuditoria = idUsuarioAuditoria;
        adminService.SetUpdatePasswordUsuario(data).then(
            response => {

                const {status, msg} = response;

                if (status) {
                    dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertSuccess , message: msg } });
                    modalSideService.clear();
                } else {
                    dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: msg } });
                }


            },
            error => {
                dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: error.toString() } });
            }
        );
    }

    const onErrorSubmit = errors => {
        console.log(errors)
    }

    return(
        <FormProvider {...methods} >
            <form className="d-flex flex-column justify-content-between align-items-center h-100">

            <div className="container mx-0 px-0 w-100 mw-100 my-3">
                <header className="mx-2 text-center text-muted content-divider divider-form">
                    <span className="px-2" style={{color: Colors.COLOR_SKY_THEME}}>Información Usuario</span>
                </header>
                <div className="row mx-0 px-0 my-2">
                    <InputForm inputProps={{control}} readOnly={true} disabled={!isEditing} identificador="idUsuario" label="Usuario"
                               placeholder="Ej: C109876566" type="text" required={true} className={`px-2 col-12`}
                               customError={errors.idUsuario ? ERRORFIELDREQUIRED : null}/>
                </div>

                <header className="mx-2 text-center text-muted content-divider divider-form">
                    <span className="px-2" style={{color: Colors.COLOR_SKY_THEME}}>Credenciales</span>
                </header>
                <div className="row mx-0 px-0 my-2">
                    <InputForm inputProps={{control}} disabled={!isEditing} identificador="newPassword" label="Contraseña Nueva"
                               placeholder="Ej: C109876566" type="password" required={true} className={`px-2 col-12`}
                               customError={errors.newPassword ? ERRORFIELDREQUIRED : null}/>
                    <InputForm inputProps={{control}} disabled={!isEditing} identificador="confirmNewPassword" label="Confirmar Contraseña Nueva"
                               placeholder="Ej: C109876566" type="password" required={true} className={`px-2 col-12`}
                               rules={{ validate: value => value === newPassword || "*La contraseña no coincide" }}
                               customError={errors.confirmNewPassword ? errors.confirmNewPassword.message : null}/>
                </div>


            </div>

            <div className="w-75 mb-2">


                <CButton onClick={handleSubmit(onSuccessSubmit, onErrorSubmit)} style={{borderRadius: 100, letterSpacing: 1.3}}
                         color="info" className="mt-4 w-100 p-2 text-uppercase" shape="rounded-pill">Guardar Cambios</CButton>

            </div>
        </form>
        </FormProvider>
    )

}

export default FormUsuariosPasswordCRUD;
